import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalTitle, ModalFooter } from "@vds/modals";
import { Dropdown } from "primereact/dropdown";
import { SLButton } from "../../components/core/Controls";
import Icon from "@vds/icons";
import { StyledModal } from "./RescheduleModal";
import moment from "moment";
import { FlexRow, SmallText, Spacer } from "../../components/core/Utility";
import { TextArea } from "@vds/inputs";
import { Title } from "@vds/typography";
import { CustomisedInput } from "./CompleteJob";

const ConfirmationModal = ({ setConfirmModal, type, reschedule, selectedSlot, timezone, handleSupplyNotes }) => {
  const [disabled, setDisabled] = useState(false);
  const [notes, setNotes] = useState("");
  const [initialCancelReason, setInitialCancelReason] = useState("");

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setConfirmModal(null);
      }
    };
    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, []);

  const handleNotes = (value) => {
    value.length > 500 ? setDisabled(true) : setDisabled(false);
    setNotes(value);
  };
  const initialCancelReasonList = [
    "Checking availability for date/time",
    "Checking for Installer Coverage Area",
    "Enter Incorrect Time/Date/Duration",
    "Date/Time didn't work out for Customer",
    "Customer not ready for schedule",
  ];
  return (
    <Modal
      hideCloseButton={false}
      opened={true}
      disableOutsideClick
      css={StyledModal}
      closeButton={
        <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
          <Title size="medium">
            {type === "schedule"
              ? `Schedule Job?`
              : type === "reschedule"
              ? `Reschedule job?`
              : reschedule
              ? `Cancel rescheduling job?`
              : `Cancel scheduling job?`}
          </Title>

          <div onClick={() => setConfirmModal(null)} style={{ marginRight: "1rem", marginTop: "0.3rem" }}>
            <Icon name="close" size="medium" color="#000000" style={{ cursor: "pointer", outline: "none" }} />
          </div>
        </FlexRow>
      }
    >
      <ModalBody css={{ paddingLeft: "0", paddingRight: "0" }}>
        {type === "cancel" ? (
          <>
            <FlexRow justifyContent="space-between" marginBottom="8.5rem">
              <SmallText>Please Provide Reason for Abandoning Job</SmallText>
              <Dropdown
                value={initialCancelReason || "Please select"}
                options={initialCancelReasonList}
                onChange={(e) => setInitialCancelReason(e.target.value)}
                css={[CustomisedInput, { width: "71%", marginTop: "0.2rem" }]}
                scrollHeight="7.5rem"
                placeholder="Please select"
              />
            </FlexRow>
            <SmallText fontWeight="normal">You will lose any changes you made</SmallText>
          </>
        ) : type === "schedule" ? (
          <>
            <SmallText fontWeight="normal">
              The job will be scheduled for {moment(selectedSlot.availableDate).format("dddd")}, {moment(selectedSlot.availableDate).format("LL")} at{" "}
              {moment(selectedSlot.slotStartTime, "HHmm").format("h.mm A")} {timezone}.
            </SmallText>
            <Spacer top="10px" />
            <SmallText fontWeight="normal">
              You will need to create a C4S work ticket and issue a purchase order (PO) to schedule this job. The vendor needs to receive a PO up to
              24 hours after the job was scheduled, otherwise the job might not be scheduled.
            </SmallText>
            <Spacer top="10px" />
            <TextArea
              label="Notes To Technician"
              required={false}
              helperText="Notes will be sent to the technician and can't be changed later."
              helperTextPlacement="bottom"
              maxLength={500}
              value={notes}
              onChange={(e) => handleNotes(e.target.value)}
              css={{
                fontSize: "12px",
                fontFamily: "Verizon-NHG-eTX",
                letterSpacing: "0",
              }}
            />
          </>
        ) : (
          <>
            <SmallText fontWeight="normal">
              The job will be rescheduled for {moment(selectedSlot.availableDate).format("dddd")}, {moment(selectedSlot.availableDate).format("LL")}{" "}
              at {moment(selectedSlot.slotStartTime, "HHmm").format("h.mm A")} {timezone}
            </SmallText>
          </>
        )}
      </ModalBody>
      {/* <ModalFooter> */}
      <FlexRow css={{ justifyContent: "flex-end" }}>
        <SLButton
          css={{ width: "10rem", marginLeft: "auto" }}
          size="large"
          disabled={disabled}
          onClick={() => {
            setConfirmModal(null);
            handleSupplyNotes(type === "cancel" ? initialCancelReason : notes);
          }}
        >
          {type === "cancel" ? `Yes` : `Confirm`}
        </SLButton>
        <SLButton secondary css={{ width: "10rem" }} size="large" onClick={() => setConfirmModal(null)}>
          {type === "cancel" ? `No` : `Cancel`}
        </SLButton>
      </FlexRow>
      {/* </ModalFooter> */}
    </Modal>
  );
};
export default ConfirmationModal;
